import React from "react";
import { MessageWrapper } from "./Message.less";

const Message = (props) => (
  <div className="MessageWrapper" style={props.centered === false ? { textAlign: "left" } : null}>
    {props.children}
  </div>
);

Message.defaultProps = {
  centered: true,
};

export default Message;
